export default __webpack_public_path__ + "static/media/billing.e11cc6fe.svg";